package com.daytimegaming.ourdailyfinances.domain.model

data class DashboardInvite(
    val code: String,
    val createdAt: String,
)

data class JoinedDashboard(
    val dashboardId: String,
    val name: String,
)

data class Dashboard(
    val dashboardId: String,
    val name: String,
    val ownerUserId: String,
    val invites: List<DashboardInvite>?,
)

data class DashboardDetail(
    val dashboardId: String,
    val name: String,
    val ownerUserId: String,
    val invites: List<DashboardInvite>?,
    val members: List<DashboardMember>,
    val accounts: List<DashboardAccount>,
    val transactions: List<Transaction> = emptyList(),
    val realEstateHoldings: List<RealEstateHolding> = emptyList(),
    val investments: Investments? = null,
)

data class DashboardMember(
    val userId: String,
    val email: String?,
    val firstName: String?,
    val lastName: String?,
    val joinedAt: String,
)

data class DashboardAccount(
    val accountId: String,
    val name: String,
    val officialName: String?,
    val type: String,
    val subtype: String?,
    val currentBalance: Double?,
    val availableBalance: Double?,
    val isoCurrencyCode: String?,
    val addedByUserId: String,
    val itemId: String?,
    val institutionName: String? = null,
    val loginRequired: Boolean = false,
    val updateRequired: Boolean = false,
    val subscriptionRequired: Boolean = false,
    val nickname: String? = null,
) {
    val displayName: String
        get() = if (!nickname.isNullOrEmpty()) nickname else name
}

data class DashboardPreview(
    val dashboardId: String,
    val name: String,
    val createdAt: String,
    val ownerName: String,
    val members: List<String>,
)
